module.exports = __webpack_public_path__ + "img/devicewifiid.4ef4d86f.png";